import React from "react";

/**
 * Reusable shell for every legal page (Terms, Refunds, Responsible
 * Gambling, extended Privacy). Provides consistent header + body
 * padding + centered max-width so every legal page has the same
 * feel and readability. Also sets `data-testid` so QA can assert
 * page-render without scraping copy.
 */
export default function LegalShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white" data-testid={`legal-page-${title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
      <div className="max-w-3xl mx-auto px-6 py-16">
        <a href="/" className="mono text-[10px] uppercase tracking-widest text-[#39FF14] hover:text-white transition-colors">← Back to WarPaint DFS</a>
        <h1 className="heading text-4xl font-black uppercase mb-2 mt-6">{title}</h1>
        {subtitle && <div className="overline mb-10">{subtitle}</div>}
        <div className="space-y-8">
          {children}
        </div>
        <div className="mt-16 pt-8 border-t border-zinc-900 flex flex-wrap items-center gap-6 text-[10px] mono uppercase tracking-widest text-zinc-500">
          <a href="/terms" className="hover:text-white">Terms</a>
          <a href="/privacy" className="hover:text-white">Privacy</a>
          <a href="/refunds" className="hover:text-white">Refunds</a>
          <a href="/responsible-gambling" className="hover:text-white">Play Responsibly</a>
          <a href="mailto:support@warpaintdfs.com" className="hover:text-white">Contact</a>
        </div>
      </div>
    </div>
  );
}
